"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function CoastalFootnotes() {
  return <section id="coastal-footnotes" className="dark bg-background text-foreground pt-16 pb-8 px-4 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="space-y-6 flex flex-col items-start">
            
            <Badge variant="outline" className="border-primary/50 text-primary bg-primary/10 py-1 px-3">
              30+ Years Experience
            </Badge>
          </div>

          {}
          <div>
            <h3 className="font-semibold text-lg mb-6 text-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-semibold text-lg mb-6 text-foreground">
              Contact Info
            </h3>
            <ul className="space-y-4 text-muted-foreground text-sm">
              <li className="flex items-start gap-3">
                <Phone className="size-4 text-primary shrink-0 mt-0.5" />
                <Link to="tel:0413771815" className="hover:text-primary transition-colors">
                  0413 771 815
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="size-4 text-primary shrink-0 mt-0.5" />
                <Link to="mailto:Folppclint430@gmail.com" className="hover:text-primary transition-colors">
                  Folppclint430@gmail.com
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="size-4 text-primary shrink-0 mt-0.5" />
                <span className="leading-relaxed">
                  Gorokan, Toukley, Norah Head, Gwandalan, Budgewoi, Lake Haven,
                  Charmhaven and surrounding Northern Central Coast suburbs.
                </span>
              </li>
            </ul>
          </div>

          {}
          
        </div>

        <Separator className="bg-border/50 mb-8" />

        <div className="flex flex-col items-center justify-center gap-2 text-sm text-muted-foreground text-center">
          <p className="font-medium text-foreground/80">ABN 54205050949</p>
          <p>
            2026 website build by{" "}
            <Link to="https://www.websiteshop.com.au" className="text-accent hover:underline transition-colors" target="_blank" rel="noopener noreferrer">
              Website Shop
            </Link>
          </p>
        </div>
      </div>
    </section>;
}